// No imports on purpose: the merge is unit-tested, and anything that pulls
// axios into a Jest test needs its ESM entry mocked first.

/**
 * Books Written after the recommender's name finds `matches` (their books, by
 * author name). Replaces only what the previous auto-fill added
 * (`previousAuto`, a Set of bookIds): series and books the admin picked by
 * hand stay where they are, and the new matches follow. The auto-fill fires
 * on every name edit, the edit form included, so replacing the whole list
 * threw away an admin's picks whenever a typo in the name was fixed.
 */
export const mergeAutoBooksWritten = (current = [], matches = [], previousAuto = new Set()) => {
  const kept = current.filter((entry) => entry.seriesId || !previousAuto.has(String(entry.bookId)));
  const keptIds = new Set(kept.map((entry) => String(entry.bookId)));
  const added = matches.filter((book) => !keptIds.has(String(book.bookId)));
  return [...kept, ...added];
};
